// extracted by mini-css-extract-plugin
export default {"container":"Subscription_container__yQ1w0","validity":"Subscription_validity__ulsS5","subtitle":"Subscription_subtitle__ouPt3","noplan":"Subscription_noplan__AuxdN"};